// dawid-front/src/app/engine/utils.js
// Pure helpers ported from src/app/utils.js (duplicated, not re-exported).
// NOTE: lodash is NOT imported here; structuredClone is used where needed.

export function removeDeprecatedOptions(initialState, field, fieldIndex) {
    if (initialState === undefined || initialState.values === undefined) {
        return initialState;
    }
    if (field.type !== 'dropdown' || field.allowAdditions) {
        return initialState;
    }
    const uniqueOptionsValues = new Set();
    if (field.options) {
        field.options.forEach((option) => uniqueOptionsValues.add(option.value));
    }
    const oldValues = initialState.values[fieldIndex];
    if (oldValues === undefined) {
        return initialState;
    }
    let newValues;
    if (field.multiple) {
        const arr = Array.isArray(oldValues) ? oldValues : [oldValues];
        newValues = arr.filter((v) => uniqueOptionsValues.has(v));
    } else if (uniqueOptionsValues.has(oldValues)) {
        newValues = oldValues;
    } else {
        newValues = undefined;
    }
    if (newValues === oldValues) {
        return initialState;
    }
    const newValuesArray = [...initialState.values];
    newValuesArray[fieldIndex] = newValues;
    return { ...initialState, values: newValuesArray };
}

export function fieldsChanged(previousState, newFields) {
    if (!previousState) {
        return true;
    } else {
        const previousFields = previousState.fields;
        if (previousFields === newFields) {
            return false;
        }
        const obviousCaseChanged = previousFields === undefined
            || previousFields === null || newFields === undefined || newFields === null
            || previousFields.length !== newFields.length;
        if (obviousCaseChanged) {
            return obviousCaseChanged;
        }
        for (let i = 0; i < previousFields.length; i++) {
            if (previousFields[i].label !== newFields[i].label) {
                return true;
            }
        }
        return false;


    }
}

export function getShortLoopName(loopName) {
    let shortName = loopName.substring(loopName.lastIndexOf(LOOPS_COMPONENTS_SEPARATOR) + 1);
    if (shortName === undefined) {
        shortName = loopName;
    }
    shortName = shortName.substring(0, shortName.lastIndexOf('$')) || shortName;
    return shortName;
}

export function getAllLoopsName(loopName) {
    return loopName.split(LOOPS_COMPONENTS_SEPARATOR)
}

const LOOPS_INDEX_SEPARATOR = '$';
export const LOOPS_COMPONENTS_SEPARATOR = "#";

export function getParentLoopName(loopName) {
    const index = loopName.indexOf(LOOPS_COMPONENTS_SEPARATOR);
    if (index === -1) {
        return loopName;
    }
    return loopName.substring(0, index);
}

function findInPath(state, itemId, group) {
    for (let i = 0; i < state.path.length; i++) {
        if (state.path[i].itemId === itemId && state.path[i].group === group) {
            return i;
        }
    }
    return -1;
}

export function buildPath(state, currentItemId, currentGroup, nextItemId, loopName, nextGroup) {
    const pos = findInPath(state, currentItemId, currentGroup);
    const posExisting = findInPath(state, nextItemId, nextGroup);
    let path = [...state.path];
    if (posExisting !== -1) {
        path.splice(posExisting + 1);
        let loop = null;
        // we update the metadata associated to this pathItem
        // to point to the last loop index
        if (loopName) {
            const loopState = state.loops[loopName];
            const loopIndex = loopState ? loopState.index : 1;
            loop = {loopName, loopIndex, group: nextGroup};
        }
        path[posExisting].loop = loop;
        path[posExisting].group = nextGroup;
    } else {
        path.splice(pos + 1);
        let loop = null;
        if (loopName) {
            const loopState = state.loops[loopName];
            const loopIndex = loopState ? loopState.index : 1;
            loop = {loopName, loopIndex, group: nextGroup};
        }
        path.push({
            itemId: nextItemId,
            loop,
            group: nextGroup
        });
    }
    return path;
}

// returns { hasIncomplete: boolean, loops: updatedLoops }
export function checkCompleteLoop(loopName, loops) {
    const previousLoop = loops[loopName];
    const newValidIterations = [...previousLoop.validIterations];
    newValidIterations[previousLoop.index - 1] = true;
    const newLoop = { ...previousLoop, validIterations: newValidIterations };
    let newLoops = { ...loops, [loopName]: newLoop };

    let hasIncomplete = false;
    for (let i = 0; i < newValidIterations.length; i++) {
        if (newValidIterations[i] === false) {
            hasIncomplete = true;
            break;
        }
    }

    if (!hasIncomplete) {
        const parentLoopName = loopName.substring(0, loopName.indexOf('#'));
        if (parentLoopName !== '') {
            const parentResult = checkCompleteLoop(parentLoopName, newLoops);
            return { hasIncomplete: parentResult.hasIncomplete, loops: parentResult.loops };
        }
    }
    return { hasIncomplete, loops: newLoops };
}
